import {
  Create,
  ListButton,
  required,
  SaveButton,
  SimpleForm,
  TextInput,
  Toolbar,
  TopToolbar,
} from "react-admin";

import { RolesTableInput } from "@/inputs/RolesTableInput";

const CreateToolbar = () => (
  <Toolbar sx={{ gap: 2 }}>
    <SaveButton label="Create" alwaysEnable />
    <ListButton label="Cancel" icon={null} variant="outlined" size="medium" />
  </Toolbar>
);

const CreateActions = () => (
  <TopToolbar sx={{ justifyContent: "flex-start" }}>
    <ListButton />
  </TopToolbar>
);

export const GroupCreate = () => {
  const defaultValues = {
    name: "",
    description: "",
    roles: [],
  };

  return (
    <Create actions={<CreateActions />} redirect="list">
      <SimpleForm toolbar={<CreateToolbar />} defaultValues={defaultValues}>
        <TextInput source="name" isRequired={true} validate={required()} />
        <TextInput
          source="description"
          isRequired={true}
          validate={required()}
        />
        <RolesTableInput source="roles" label="Methods list" />
      </SimpleForm>
    </Create>
  );
};
